export default __webpack_public_path__ + "static/media/raffle.3684d5c6.png";